<template>
  <b-modal
    :id="id"
    :title="trans('gender_choices')"
    :ok-title="trans('save')"
    :ok-disabled="!options || options.length == 0"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onSave"
  >
    <b-form-group :label="trans('gender_choices_about')">
      <b-form-checkbox-group
        stacked
        v-model="options"
        :options="genderOptions"
      ></b-form-checkbox-group>
    </b-form-group>
    <b-form-group>
      <b-button variant="outline-primary" size="sm" @click="onSelectAll">
        <i class="fa fa-fw fa-check-circle"></i>
        {{ trans('select_all') }}
      </b-button>
    </b-form-group>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'gender-choices-modal',
      },
      organization: Object,
      value: Array,
    },
    data() {
      return {
        trans: trans,
        genderOptions: [
          {value: 'Male', text: trans('gender_Male')},
          {value: 'Female', text: trans('gender_Female')},
          {value: 'Transmasculine', text: trans('gender_Transmasculine')},
          {value: 'Transfeminine', text: trans('gender_Transfeminine')},
          {value: 'NonBinary', text: trans('gender_NonBinary')},
          {value: 'TwoSpirit', text: trans('gender_TwoSpirit')},
          {value: 'Other', text: trans('gender_Other')},
          {value: 'NotSpecified', text: trans('gender_NotSpecified')},
          {value: 'PreferNotToSay', text: trans('gender_PreferNotToSay')},
        ],
        options: _.clone(_.allGenderChoices),
      }
    },
    methods: {
      onShown() {
        let value = !this.value ? _.allGenderChoices : this.value
        this.options = _.clone(value)
      },
      onSelectAll() {
        this.options = _.clone(_.allGenderChoices)
      },
      onSave() {
        let options = _.isEqual(this.options, _.allGenderChoices) ? null : this.options
        this.$bvModal.hide(this.id)
        this.$emit('input', options)
      },
    }
  }
</script>